import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=227716e0&"
import script from "./change-password.vue?vue&type=script&lang=ts&"
export * from "./change-password.vue?vue&type=script&lang=ts&"
import style0 from "./change-password.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports